module.exports = __webpack_public_path__ + "static/media/awards_5.4ab21e9c.jpg";